import api from '../token';

export const DeleteImposto = async (dados) => {
  try {
    const response = await api.post('/deleteImposto', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};



